import Vue from 'vue'
import Router from 'vue-router'

import login from 'comman/login.vue'
import forgetPassword from 'comman/ForgetPassword.vue'
// import home from 'microfinance/Dashboard.vue'
import apitesting from 'microfinance/master/ApiTesting.vue'
import state from 'microfinance/master/State.vue'
import designation from 'microfinance/master/Designation.vue'
import loanPlan from 'microfinance/master/LoanPlan.vue'
import bank from 'microfinance/master/Bank.vue'
import sessionMaster from 'microfinance/master/SessionMaster.vue'
import softwareTiming from 'microfinance/master/SoftwareTiming.vue'
import feesMaster from 'microfinance/master/FeesMaster.vue'
import seriesMaster from 'microfinance/master/SeriesMaster.vue'
import leaveMaster from 'microfinance/master/LeaveMaster.vue'
import deductionMaster from 'microfinance/master/DeductionMaster.vue'
import mixedMaster from 'microfinance/master/MixedMaster.vue'
import branches from 'microfinance/master/company/Branches.vue'
import staffbranches from 'microfinance/master/company/StaffBranch.vue'
import branchCenter from 'microfinance/master/company/BranchCenter.vue'
import areaSurvey from 'microfinance/master/company/AreaSurvey.vue'
import groupMaster from 'microfinance/master/company/GroupMaster.vue'
import profile from 'comman/Profile.vue'
import setting from 'microfinance/master/company/Profile.vue'
import smssetting from 'microfinance/master/company/SmsSetting.vue'
import bankAccounts from 'microfinance/master/company/BankAccounts.vue'
import customer from 'microfinance/Customer/Customer.vue'
import customerGroup from 'microfinance/Customer/CustomerGroup.vue'
import loanMaster from 'microfinance/Loan/LoanMaster.vue'
import downloadloanform from 'microfinance/Loan/DownloadLoanForm.vue'
import loantopup from 'microfinance/Loan/LoanTopup.vue'
import individualLoan from 'microfinance/Loan/IndividualLoan.vue'
import groupLoan from 'microfinance/Loan/GroupLoan.vue'
import disbursment from 'microfinance/Loan/Disbursment.vue'
import groupMemberDisbursment from 'microfinance/Loan/GroupMemberDisbursment.vue'
import groupDisbursment from 'microfinance/Loan/GroupDisbursment.vue'
// import emiCollection from 'microfinance/Collection/EMICollection.vue'
import emiCollection from 'microfinance/Collection/DuePaymentList.vue'
import groupEmiCollection from 'microfinance/Collection/GroupEMICollection.vue'
import promisetopay from 'microfinance/Collection/PromiseToPay.vue'
import memberCollection from 'microfinance/Collection/MemberCollection.vue'
import oldMemberCollection from 'microfinance/Loan/MemberCollection.vue'
import customerdetails from 'microfinance/Loan/CustomerDetails.vue'
import customerloandetails from 'microfinance/Customer/CustomerLoanDetail.vue'
import loanSummary from 'microfinance/Loan/LoanSummary.vue'
import loanDetail from 'microfinance/Loan/LoanDetails.vue'
import advancesecurity from 'microfinance/Collection/AdvanceSecurity.vue'
import showCollection from 'microfinance/Collection/ShowCollection.vue'
import collection from 'microfinance/Approvals/Collection.vue'
import paymentStatus from 'comman/Thankyou.vue'
import approveSettlement from 'microfinance/Approvals/ApproveSettlement.vue'
import approvesalary from 'microfinance/Approvals/ApproveSalary.vue'
import recovery from 'microfinance/entry/Recovery.vue'
import loanclosure from 'microfinance/entry/LoanClosure.vue'
import settlement from 'microfinance/entry/Settlement.vue'
import deathMember from 'microfinance/entry/DeathMember.vue'
import pendingApplications from 'microfinance/Adjustments/PendingApplications.vue'
import disapproveApplications from 'microfinance/Adjustments/DisapproveApplications.vue'
import ledgerGroups from 'microfinance/master/LedgerGroups.vue'
import ledgerAccounts from 'microfinance/master/LedgerAccounts.vue'
import employee from 'microfinance/HRM/Employee.vue'
import salary from 'microfinance/HRM/Salary.vue'
import holidayMaster from 'microfinance/HRM/HolidayMaster.vue'
import attendance from 'microfinance/HRM/EmployeeAttendance.vue'
import employeeLeave from 'microfinance/HRM/EmployeeLeave.vue'
import employeeSalaryDetails from 'microfinance/HRM/EmployeeSalaryDetails.vue'
// import employeeAbsentDetails from 'microfinance/HRM/EmployeeAbsentDetails.vue'
import printemployeeletters from 'microfinance/HRM/PrintEmployeeLetter.vue'

// import sunday from 'microfinance/HRM/Sunday.vue'
import employeeloantransfer from 'microfinance/Utilities/EmployeeLoanTransfer.vue'
import employeememberloantransfer from 'microfinance/Utilities/EmployeeMemberLoanTransfer.vue'
import employeemembertransfer from 'microfinance/Utilities/EmployeeMemberTransfer.vue'
import centerDayShift from 'microfinance/Utilities/CenterDayShift.vue'
import updateCenterLeader from 'microfinance/Utilities/UpdateCenterLeader.vue'
// import confirmationletter from 'microfinance/components/ConfirmationLetter.vue'
// import experienceletter from 'microfinance/components/ExperienceLetter.vue'
// import relievingletter from 'microfinance/components/Relievingletter.vue'
// import cibil
import cibil from 'microfinance/Utilities/Cibil.vue'
import logs from 'microfinance/Utilities/Logs.vue'
import loanhistory from 'microfinance/Utilities/LoanHistory.vue'
import duplicateloan from 'microfinance/Utilities/DuplicateLoan.vue'
import Ledger from 'microfinance/accounting/Ledger.vue'
// import portfolio from 'microfinance/accounting/Portfolio.vue'
import BranchLedger from 'microfinance/accounting/BranchLedger.vue'
// important accounting portions
import profitloss from 'microfinance/accounting/ProfitLoss.vue'
import Group from 'microfinance/accounting/Group.vue'
import Cashbook from 'microfinance/accounting/CashBook.vue'
import fundtransfer from 'microfinance/accounting/FundTransfer.vue'
import PaymentVoucher from 'microfinance/accounting/PaymentVoucher.vue'
import ReceiptVoucher from 'microfinance/accounting/ReceiptVoucher.vue'
import ContraVoucher from 'microfinance/accounting/ContraVoucher.vue'
import JournalVoucher from 'microfinance/accounting/JournalVoucher.vue'
import Voucher from 'microfinance/accounting/Voucher.vue'
import FYVoucherStatement from 'microfinance/accounting/FinancialYearVoucherStatement.vue'
import daybook from 'microfinance/accounting/Daybook.vue'
import TrailBalance from 'microfinance/accounting/TrailBalance.vue'
import FYTrialBalance from 'microfinance/accounting/FYTrialBalance.vue'
import FYOpeningBalance from 'microfinance/accounting/FYOpeningBalance.vue'
import Permission from 'microfinance/rolePermission/Permission.vue'
import Role from 'microfinance/rolePermission/Role.vue'
// important reporting section for
import memberemipaymentattendance from 'microfinance/Reports/MemberPaymentAttendance.vue'
import DisbursementReport from 'microfinance/Reports/DisbursementReport.vue'
import SettlementReport from 'microfinance/Reports/SettlementReport.vue'
import CollectionReport from 'microfinance/Reports/CollectionReport.vue'
import DueEmiReport from 'microfinance/Reports/DueEmiReports.vue'
import OnlinePaymentReport from 'microfinance/Reports/OnlinePaymentReport.vue'
import LoanReport from 'microfinance/Reports/LoanReport.vue'
// const PageNotFound = Vue.component('error', require('comman/Error.vue').default)
import Error403 from 'comman/Error403.vue'
import PageNotFound from 'comman/Error.vue'

import Hello from 'components/Hello.vue'
import Dashboard from 'examples/Dashboard.v1.vue'

Vue.use(Router)

// export default new Router({
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/hello',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/forget',
      name: 'forgetPassword',
      component: forgetPassword
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/', // dashboard/v
      name: 'Dashboard',
      component: Dashboard
    },
    {path: '/home', name: 'Home', component: Dashboard},
    {path: '/apitesting', name: 'apitesting', component: apitesting, meta: {authRequired: 'true'}},
    {path: '/state', name: 'State', component: state, meta: {authRequired: 'true'}},
    {path: '/designation', name: 'designation', component: designation, meta: {authRequired: 'true'}},
    {path: '/loanplan', name: 'loanplan', component: loanPlan, meta: {authRequired: 'true'}},
    {path: '/bank', name: 'bank', component: bank, meta: {authRequired: 'true'}},
    {path: '/sessionMaster', name: 'sessionMaster', component: sessionMaster, meta: {authRequired: 'true'}},
    {path: '/softwareTiming', name: 'softwareTiming', component: softwareTiming, meta: {authRequired: 'true'}},
    {path: '/fees', name: 'fees', component: feesMaster, meta: {authRequired: 'true'}},
    {path: '/series', name: 'series', component: seriesMaster, meta: {authRequired: 'true'}},
    {path: '/leave', name: 'leave', component: leaveMaster, meta: {authRequired: 'true'}},
    {path: '/deduction', name: 'deduction', component: deductionMaster, meta: {authRequired: 'true'}},
    {path: '/mixed', name: 'mixed', component: mixedMaster, meta: {authRequired: 'true'}},
    {path: '/branches', name: 'branches', component: branches, meta: {authRequired: 'true'}},
    {path: '/staffbranches', name: 'staffbranches', component: staffbranches, meta: {authRequired: 'true'}},
    {path: '/branchCenter', name: 'branchCenter', component: branchCenter, meta: {authRequired: 'true'}},
    {path: '/areaSurvey', name: 'areaSurvey', component: areaSurvey, meta: {authRequired: 'true'}},
    {path: '/profitloss', name: 'profitloss', component: profitloss, meta: {authRequired: 'true'}},
    {path: '/group', name: 'group', component: groupMaster, meta: {authRequired: 'true'}},
    {path: '/profile', name: 'profile', component: profile},
    {path: '/setting', name: 'setting', component: setting, meta: {authRequired: 'true'}},
    {path: '/smssetting', name: 'smssetting', component: smssetting, meta: {authRequired: 'true'}},
    {path: '/bankAccounts', name: 'bankAccounts', component: bankAccounts, meta: {authRequired: 'true'}},
    {path: '/customer', name: 'customer', component: customer, meta: {authRequired: 'true'}},
    {path: '/customergroup', name: 'customergroup', component: customerGroup, meta: {authRequired: 'true'}},
    {path: '/customerdetails/:memberUserId', name: 'customerdetails', component: customerdetails, meta: {authRequired: 'true'}},
    {path: '/customerloandetails/:memberUserId', name: 'customerloandetails', component: customerloandetails, meta: {authRequired: 'true'}},
    {path: '/loan', name: 'loan', component: loanMaster, meta: {authRequired: 'true'}},
    {path: '/downloadloanform', name: 'downloadloanform', component: downloadloanform, meta: {authRequired: 'true'}},
    {path: '/loantopup', name: 'loantopup', component: loantopup, meta: {authRequired: 'true'}},
    {path: '/individualLoan', name: 'individualLoan', component: individualLoan, meta: {authRequired: 'true'}},
    {path: '/groupLoan', name: 'groupLoan', component: groupLoan, meta: {authRequired: 'true'}},
    {path: '/disbursment', name: 'disbursment', component: disbursment, meta: {authRequired: 'true'}},
    {path: '/groupMemberDisbursment', name: 'groupMemberDisbursment', component: groupMemberDisbursment, meta: {authRequired: 'true'}},
    {path: '/groupDisbursment', name: 'groupDisbursment', component: groupDisbursment, meta: {authRequired: 'true'}},
    {path: '/promisetopay', name: 'promisetopay', component: promisetopay, meta: {authRequired: 'true'}},
    {path: '/emiCollection', name: 'emiCollection', component: emiCollection, meta: {authRequired: 'true'}},
    {path: '/groupEmiCollection', name: 'groupEmiCollection', component: groupEmiCollection, meta: {authRequired: 'true'}},
    {path: '/oldMemberCollection', name: 'oldMemberCollection', component: oldMemberCollection, meta: {authRequired: 'true'}},
    {path: '/memberCollection', name: 'memberCollection', component: memberCollection, meta: {authRequired: 'true'}},
    {path: '/loanSummary', name: 'loanSummary', component: loanSummary, meta: {authRequired: 'true'}},
    {path: '/loanDetail/:memberLoanId/:disbursmentId', name: 'loanDetail', component: loanDetail, meta: {authRequired: 'true'}},
    {path: '/advancesecurity', name: 'advancesecurity', component: advancesecurity, meta: {authRequired: 'true'}},
    {path: '/showCollection', name: 'showCollection', component: showCollection, meta: {authRequired: 'true'}},
    {path: '/collection', name: 'collection', component: collection, meta: {authRequired: 'true'}},
    {path: '/payment/status', name: 'status', component: paymentStatus, meta: {authRequired: 'true'}},
    {path: '/approvesalary', name: 'approvesalary', component: approvesalary, meta: {authRequired: 'true'}},
    {path: '/approveSettlement', name: 'approveSettlement', component: approveSettlement, meta: {authRequired: 'true'}},
    {path: '/recovery', name: 'recovery', component: recovery, meta: {authRequired: 'true'}},
    {path: '/loanclosure', name: 'loanclosure', component: loanclosure, meta: {authRequired: 'true'}},
    {path: '/settlement', name: 'settlement', component: settlement, meta: {authRequired: 'true'}},
    {path: '/deathMember', name: 'deathMember', component: deathMember, meta: {authRequired: 'true'}},
    {path: '/pendingApplications', name: 'pendingApplications', component: pendingApplications, meta: {authRequired: 'true'}},
    {path: '/disapproveApplications', name: 'disapproveApplications', component: disapproveApplications, meta: {authRequired: 'true'}},
    {path: '/ledgerGroups', name: 'ledgerGroups', component: ledgerGroups, meta: {authRequired: 'true'}},
    {path: '/ledgerAccounts', name: 'ledgerAccounts', component: ledgerAccounts, meta: {authRequired: 'true'}},
    {path: '/employee', name: 'employee', component: employee, meta: {authRequired: 'true'}},
    {path: '/salary', name: 'salary', component: salary, meta: {authRequired: 'true'}},
    {path: '/holiday', name: 'holiday', component: holidayMaster, meta: {authRequired: 'true'}},
    {path: '/attendance', name: 'attendance', component: attendance, meta: {authRequired: 'true'}},
    // {path: '/employeeAbsentDetails', name: 'employeeAbsentDetails', employeeAbsentDetails, meta: {authRequired: 'true'}},
    {path: '/employeeleave', name: 'employeeleave', component: employeeLeave, meta: {authRequired: 'true'}},
    {path: '/employeeSalaryDetails', name: 'employeeSalaryDetails', component: employeeSalaryDetails, meta: {authRequired: 'true'}},
    {path: '/printemployeeletters', name: 'printemployeeletters', component: printemployeeletters, meta: {authRequired: 'true'}},
    // {path: '/sunday', name: 'sunday', component: sunday},
    {path: '/employeeloantransfer', name: 'employeeloantransfer', component: employeeloantransfer, meta: {authRequired: 'true'}},
    {path: '/employeememberloantransfer', name: 'employeememberloantransfer', component: employeememberloantransfer, meta: {authRequired: 'true'}},
    {path: '/employeemembertransfer', name: 'employeemembertransfer', component: employeemembertransfer, meta: {authRequired: 'true'}},
    {path: '/centerdayshift', name: 'centerdayshift', component: centerDayShift, meta: {authRequired: 'true'}},
    {path: '/updatecenterleader', name: 'updatecenterleader', component: updateCenterLeader, meta: {authRequired: 'true'}},
    // cibil portions
    {path: '/cibil', name: 'cibil', component: cibil, meta: {authRequired: 'true'}},
    {path: '/logs', name: 'logs', component: logs, meta: {authRequired: 'true'}},
    {path: '/loanhistory', name: 'loanhistory', component: loanhistory, meta: {authRequired: 'true'}},
    {path: '/duplicateloan', name: 'duplicateloan', component: duplicateloan, meta: {authRequired: 'true'}},
    // accounting portions
    {path: '/acgroup', name: 'acgroup', component: Group, meta: {authRequired: 'true'}},
    {path: '/cashbook', name: 'cashbook', component: Cashbook, meta: {authRequired: 'true'}},
    {path: '/fundtransfer', name: 'fundtransfer', component: fundtransfer, meta: {authRequired: 'true'}},
    {path: '/ledger', name: 'ledger', component: Ledger, meta: {authRequired: 'true'}},
    // {path: '/portfolio', name: 'portfolio', component: portfolio, meta: {authRequired: 'true'}},
    {path: '/branchLedger', name: 'branchLedger', component: BranchLedger, meta: {authRequired: 'true'}},
    {path: '/paymentvoucher', name: 'paymentvoucher', component: PaymentVoucher, meta: {authRequired: 'true'}},
    {path: '/receiptvoucher', name: 'receiptvoucher', component: ReceiptVoucher, meta: {authRequired: 'true'}},
    {path: '/contravoucher', name: 'contravoucher', component: ContraVoucher, meta: {authRequired: 'true'}},
    {path: '/journalvoucher', name: 'journalvoucher', component: JournalVoucher, meta: {authRequired: 'true'}},
    {path: '/voucher', name: 'voucher', component: Voucher, meta: {authRequired: 'true'}},
    {path: '/FYVoucherStatement', name: 'FYVoucherStatement', component: FYVoucherStatement, meta: {authRequired: 'true'}},
    {path: '/daybook', name: 'daybook', component: daybook, meta: {authRequired: 'true'}},
    {path: '/trailbalance', name: 'trailbalance', component: TrailBalance, meta: {authRequired: 'true'}},
    {path: '/FYTrialBalance', name: 'FYTrialBalance', component: FYTrialBalance, meta: {authRequired: 'true'}},
    {path: '/FYOpeningBalance', name: 'FYOpeningBalance', component: FYOpeningBalance, meta: {authRequired: 'true'}},
    // reporting showCollection
    {path: '/memberemipaymentattendance', name: 'memberemipaymentattendance', component: memberemipaymentattendance, meta: {authRequired: 'true'}},
    {path: '/DisbursementReport', name: 'DisbursementReport', component: DisbursementReport, meta: {authRequired: 'true'}},
    {path: '/SettlementReport', name: 'SettlementReport', component: SettlementReport, meta: {authRequired: 'true'}},
    {path: '/DueEmiReport', name: 'DueEmiReport', component: DueEmiReport, meta: {authRequired: 'true'}},
    {path: '/CollectionReport', name: 'CollectionReport', component: CollectionReport, meta: {authRequired: 'true'}},
    {path: '/OnlinePaymentReport', name: 'OnlinePaymentReport', component: OnlinePaymentReport, meta: {authRequired: 'true'}},
    {path: '/LoanReport', name: 'LoanReport', component: LoanReport, meta: {authRequired: 'true'}},
    {path: '/permission', name: 'permission', component: Permission, meta: {authRequired: 'true'}},
    {path: '/role', name: 'role', component: Role, meta: {authRequired: 'true'}},

    { path: '/Error403', name: 'Error403', component: Error403 },
    { path: '/404', name: 'PageNotFound', component: PageNotFound },
    { path: '*', redirect: '/404' }
  ],
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
    /* // Smooth scrolling
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    } */
  }
})
router.beforeEach((to, from, next) => {
  if (to.name === 'login' && localStorage.getItem('token')) {
    router.push({name: 'home'})
  } else if (to.meta.authRequired) {
    if (!localStorage.getItem('token')) {
      router.push({name: 'login', query: {to: to.name}})
    } else {
      // alert('123' + to.name)
      /* if (!this.hasAccess(to.name)) {
        router.push({name: 'PageNotFound'})
      } */
      var permissions = localStorage.permissions
      switch (to.name) {
        case 'Home':
          return true
        case 'apitesting':
          (permissions.includes('menu-portfolio')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'State':
          (permissions.includes('menu-state')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'bank':
          (permissions.includes('menu-bank')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'sessionMaster':
          (permissions.includes('menu-session')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'designation':
          (permissions.includes('menu-designation')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'loanplan':
          (permissions.includes('menu-loan-plan')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'leave':
          (permissions.includes('menu-leave')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'branches':
          (permissions.includes('menu-branch')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'staffbranches':
          (permissions.includes('menu-staff-branches')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'branchCenter':
          (permissions.includes('menu-branch-center')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'areaSurvey':
          (permissions.includes('menu-area-survey')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'employeeAbsentDetails':
          (permissions.includes('absent-view-any')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'branchLedger':
          (permissions.includes('menu-branch-ledger')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'centerdayshift':
          (permissions.includes('center-day-shift-view-any')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'group':
          (permissions.includes('menu-collection-center')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'customergroup':
          (permissions.includes('menu-member-group')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'customerdetails':
          (permissions.includes('member-collection-view')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'customerloandetails':
          (permissions.includes('member-collection-view')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'loan':
          (permissions.includes('loan-disbursement-view-any')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'downloadloanform':
          (permissions.includes('menu-download-loan-form')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'loantopup':
          (permissions.includes('menu-individual-loan')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'individualLoan':
          (permissions.includes('menu-individual-loan')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'groupLoan':
          (permissions.includes('menu-group-loan')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'disbursment':
          (permissions.includes('menu-disbursement')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'groupMemberDisbursment':
          (permissions.includes('menu-group-disbursement')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'groupDisbursment':
          (permissions.includes('menu-group-disbursement')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'employeeleave':
          (permissions.includes('menu-employee-leave')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'printemployeeletters':
          (permissions.includes('menu-print-letter')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'employeeloantransfer':
          (permissions.includes('menu-employee-transfer')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'employeememberloantransfer':
          (permissions.includes('menu-member-transfer')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'employeemembertransfer':
          (permissions.includes('menu-member-transfer')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'cibil':
          (permissions.includes('menu-cibil')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'logs':
          (permissions.includes('log-activity-view')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'loanhistory':
          (permissions.includes('log-activity-view')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'duplicateloan':
          (permissions.includes('log-activity-view')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'fees':
          (permissions.includes('fee-view-any')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'profitloss':
          (permissions.includes('menu-profit-loss')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'acgroup':
          (permissions.includes('menu-groups')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'cashbook':
          (permissions.includes('menu-day-book')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'fundtransfer':
          (permissions.includes('menu-ledger')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'holiday':
          (permissions.includes('menu-holiday')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'mixed':
          (permissions.includes('menu-miscellneous')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'ledger':
          (permissions.includes('menu-ledger')) ? true : router.push({name: 'PageNotFound'})
          break
        // case 'portfolio':
        //   (permissions.includes('menu-portfolio')) ? true : router.push({name: 'PageNotFound'})
        //   break
        case 'oldMemberCollection':
          (permissions.includes('menu-member-collection')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'memberCollection':
          (permissions.includes('menu-member-collection')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'loanSummary':
          (permissions.includes('menu-loan-summery')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'loanDetail':
          (permissions.includes('member-collection-view-any')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'advancesecurity':
          (permissions.includes('menu-paid-emi')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'showCollection':
          (permissions.includes('menu-paid-emi')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'customer':
          (permissions.includes('menu-member')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'promisetopay':
          (permissions.includes('menu-promise-to-pay')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'emiCollection':
          (permissions.includes('menu-due-emi')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'groupEmiCollection':
          (permissions.includes('menu-group-emi-collection')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'employeeSalaryDetails':
          (permissions.includes('salary-disbursement-view-any')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'loanclosure':
          (permissions.includes('menu-sattlement')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'settlement':
          (permissions.includes('menu-sattlement')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'approveSettlement':
          (permissions.includes('menu-sattlement-approve')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'approvesalary':
          (permissions.includes('menu-salary-approve')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'deathMember':
          (permissions.includes('menu-death-member')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'permission':
          (permissions.includes('role-permission')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'role':
          (permissions.includes('menu-role')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'series':
          (permissions.includes('menu-series')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'setting':
          (permissions.includes('menu-setting')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'smssetting':
          (permissions.includes('menu-setting')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'softwareTiming':
          (permissions.includes('software-timing-view-any')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'employee':
          (permissions.includes('menu-employee')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'salary':
          (permissions.includes('menu-salary')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'updatecenterleader':
          (permissions.includes('menu-update-center-leader')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'voucher':
          (permissions.includes('menu-voucher')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'FYVoucherStatement':
          (permissions.includes('menu-fy-voucher-statement')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'daybook':
          (permissions.includes('menu-day-book')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'trailbalance':
          (permissions.includes('menu-trial-balance')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'FYTrialBalance':
          (permissions.includes('menu-fy-trial-balance')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'FYOpeningBalance':
          (permissions.includes('menu-fy-opening-balance')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'paymentvoucher':
          (permissions.includes('menu-payment')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'receiptvoucher':
          (permissions.includes('menu-receipt')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'contravoucher':
          (permissions.includes('menu-contra')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'journalvoucher':
          (permissions.includes('menu-journal')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'memberemipaymentattendance':
          (permissions.includes('menu-member-report')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'CollectionReport':
          (permissions.includes('menu-collection-report')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'DueEmiReport':
          (permissions.includes('menu-due-emi-report')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'DisbursementReport':
          (permissions.includes('menu-disbursement-report')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'SettlementReport':
          (permissions.includes('menu-sattlement')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'OnlinePaymentReport':
          (permissions.includes('menu-online-payment')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'LoanReport':
          (permissions.includes('menu-loan-summery')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'attendance':
          (permissions.includes('menu-attendance')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'collection':
          (permissions.includes('menu-collection-approve')) ? true : router.push({name: 'PageNotFound'})
          break
        case 'status':
          (permissions.includes('member-collection-create')) ? true : router.push({name: 'PageNotFound'})
          break
        default:
          router.push({name: 'PageNotFound'})
          return false
      }
      // console.log(permissions)
      /* if (to.name === 'State') {
        (permissions.includes('state-view-any')) ? true : router.push({name: 'PageNotFound'})
      } else if (to.name === 'bank') {
        (localStorage.permissions.includes('bank-view-any')) ? true : router.push({name: 'PageNotFound'})
      } else if (to.name === 'designation') {
        (localStorage.permissions.includes('designation-view-any')) ? true : router.push({name: 'PageNotFound'})
      } else if (to.name === 'loanplan') {
        (localStorage.permissions.includes('loan-plan-view-any')) ? true : router.push({name: 'PageNotFound'})
      } else {
        router.push({name: 'PageNotFound'})
        return false
      } */
    }
  }
  return next()
})

router.afterEach((to, from) => {
  // ...
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js